import { z } from "zod";
import { npdCanceledCalculationStatusDtoSchema } from "./npd-canceled-calculation-status.schema";
import { npdFailedCalculationStatusDtoSchema } from "./npd-failed-calculation-status.schema";
import { npdRunningCalculationStatusDtoSchema } from "./npd-running-calculation-status.schema";
import { npdSucceededCalculationStatusDtoSchema } from "./npd-succeeded-calculation-status.schema";
import { npdWaitingCalculationStatusDtoSchema } from "./npd-waiting-calculation-status.schema";
export const npdCalculationStatusDtoSchema = z.discriminatedUnion("state", [
    npdRunningCalculationStatusDtoSchema,
    npdWaitingCalculationStatusDtoSchema,
    npdSucceededCalculationStatusDtoSchema,
    npdFailedCalculationStatusDtoSchema,
    npdCanceledCalculationStatusDtoSchema,
]);
